import { useEffect, useState, useMemo } from 'react';
import { GridRowModes, useGridApiRef } from '@mui/x-data-grid-premium';

import { dataGridPremiumColumns } from '../../../utils/helper';
import useGenerateJokerCols from '../../../hooks/useGenerateJokerCols';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import { formatNumber } from '../../../utils/currencyHelper';
import { render } from '@testing-library/react';

const ProductionConfirmation = ({ disabled, autocompleteOptions, jokerLineFields, selectedValues }) => {
  const apiRef = useGridApiRef();

  //const jokerColumns = useGenerateJokerCols(jokerLineFields, 'productionItem', null);

  /*
  {
    "id": 13,
    "productionId": 29,
    "reportFormType": "1",
    "createdBy": 1,
    "createdAt": "2025-09-18T06:54:02.274Z",
    "status": "C",
    "reportType": "2",
    "itemCode": "19103",
    "rawMaterialBatch": "",
    "targDocType": null,
    "targDocId": null,
    "targGoodsIssueId": 29,
    "reportedQuantity": "0",
    "reportedQuantityWeight": "10",
    "employeeId": null,
    "markedToDel": false,
    "scrapReasonId": 1,
    "joker_char1": "raim",
    "joker_char2": "raim",
    "joker_num1": null,
    "joker_num2": null,
    "joker_num3": null,
    "joker_num4": null,
    "joker_int1": 0,
    "joker_int2": null,
    "joker_int3": null,
    "productionConfirmationMultiResource": []
}
  
  */

  const columns = () => {
    return dataGridPremiumColumns([
      {
        field: 'createdAt',
        headerName: 'Létrehozva',
        type: 'string',
        sortable: false,
        renderCell: (data) => new Date(data.row.createdAt).toLocaleString('hu-HU'),
      },
      {
        field: 'status',
        headerName: 'Státusz',
        type: 'string',
        sortable: false,
      },

      {
        field: 'itemCode',
        headerName: 'Cikkszám',
        type: 'string',
        sortable: false,
      },

      {
        field: 'reportedQuantity',
        headerName: 'Mennyiség',
        type: 'number',
        renderCell: (data) => formatNumber(data.row.reportedQuantity, 0),
      },

      {
        field: 'reportedQuantityWeight',
        headerName: 'Súly',
        type: 'number',
        renderCell: (data) => formatNumber(data.row.reportedQuantityWeight, 3),
      },

      {
        field: 'targDocId',
        headerName: 'Bevételezés azonosító',
        type: 'string',
        sortable: false,
      },
      {
        field: 'targGoodsIssueId',
        headerName: 'Kiadás azonosító',
        type: 'string',
        sortable: false,
      },

      //...jokerColumns,
    ]);
  };

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <DatagridPremiumUi
            apiRef={apiRef}
            datagridIdentifier={DataGridIdentifiers.ProductionConfirmation}
            height={480}
            columns={columns()}
            rows={selectedValues?.productionConfirmation || []}
            slots={
              {
                //toolbar: EditToolbar,
              }
            }
            slotProps={
              {
                /*toolbar: {
                    disabled,
                    push,
                    defaultItem,
                    autocompleteData,
                    apiRef,
                  },*/
              }
            }
            onCellDoubleClick={(_params, event) => {
              event.defaultMuiPrevented = true;
            }}
            headerFilters={false}
            getRowHeight={() => 'auto'}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductionConfirmation;
